import { Dashboard } from '../pages/home/types';
import { useApi } from './use-api-call';

export const useDashboardInitApi = (muted: boolean) =>
    useApi<Dashboard.DashboardDTO>('/dashboard/init-dashboard', { muted });
export const useDashboardIndicatorsApi = () => useApi('/dashboard/init-menu-indicatores');
